export const metadata = {
  title: "Venue Spotlight: FMF Futsal Arena 🔍",
  date: "2025-04-26",
  excerpt: "We shine the spotlight on the partially UEFA funded venue and home of Moldovan Futsal which is the FMF Futsal Arena",
  slug: "venue-spotlight-fmf-futsal-arena",
content: `
  Heading to Moldova now we take a look at the FMF Futsal Arena which is located just north of Chisinau, Moldova's capital.

  The stadium was inaugurated in November 2014. In terms of financing, UEFA played a pivotal role by contributing a substantial portion of the construction costs, covering approximately 70% of the expenses, which amounted to roughly 4 million euros.
  
  The Futsal Arena FMF boast seating for 1302 spectators as well as areas for journalists, photographers, and video operators. At each end of the venue there are two electronic scoreboards as well as a sound system, four fully equipped locker rooms for teams (including two locker rooms for individuals with disabilities), two locker rooms for referees, rooms for the delegate and the referee observer, a video surveillance system, a medical point, catering services, a conference room, free Wi-Fi internet, and permanently monitored parking spaces.

  Most recently the venue was used to host Group 4 in the 2025 FIFA Futsal Women's World Cup qualification (UEFA). This group saw England, Finland, Moldova and Slovenia face off and ultimately Finland progressed to the next round.
  
  The venue has also been used to host Champions league group games when Clic Chişinău was chosen as host of their group in the preliminary round.

  In addition to futsal, the Arena hosts a variety of other sporting events, including kickboxing and MMA, organized by the Fighting Entertainment Association. In 2016, it served as the venue for the FIBA European Championship for Small Countries. The facility has also been used for taekwondo, K1, and other competitions.

  Finally, following the Russian invasion of Ukraine in 2022, the Moldovan Football Federation transformed the Futsal Arena complex in Ciorescu into a temporary refugee center, providing 500 beds for displaced Ukrainians.
`,
images: [
  {
    src: "/images/blog/fmf-futsal-arena.jpg",
    alt: "Outside view",
  }
],
};
  